/**
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

import '@neo4j-ndl/base/lib/neo4j-ds-styles.css';

import { FilledButton, OutlinedButton, toast, Toaster } from '@neo4j-ndl/react';
import { CloudArrowDownIconSolid } from '@neo4j-ndl/react/icons';
import { useState } from 'react';

const Component = () => {
  const [progressBarId, setProgressBarId] = useState<string | number | null>(
    null,
  );
  return (
    <div className="n-flex n-justify-center n-gap-4">
      {/* Toaster should be at the root of the app */}
      <Toaster />
      <FilledButton
        onClick={() => {
          const id = toast.progressBar('Hello', {
            icon: <CloudArrowDownIconSolid />,
            isCloseable: true,
            shouldCloseOnAction: true,
            onClose: () => {
              setProgressBarId(null);
              console.info('close');
            },
            shouldAutoClose: false,
          });
          setProgressBarId(id);
        }}
      >
        Press to show a Toast
      </FilledButton>
      <OutlinedButton
        onClick={() => {
          if (progressBarId) {
            toast.updateProgressBarValue(progressBarId, 50);
          }
        }}
      >
        Update progress bar
      </OutlinedButton>
    </div>
  );
};

export default Component;
